/**
 * Enum for BubbleType values
 * @enum {string|*}
 */

const BubbleType = {
    AGENT_MESSAGE: 1,
    CUSTOMER_MESSAGE: 2,
    TYPING_MESSAGE: 3,
    SYSTEM_MESSAGE: 4,
    VIRTUAL_AGENT_MESSAGE: 5,
    OPENER_MESSAGE: 6,
    CONVERSATION_HEADER: 7,
    DISCLAIMER_TEXT: 8,
    RICH_MESSAGE_QR: 9,
    RICH_MESSAGE_CARD: 10,
    RICH_MESSAGE_FORM: 11,
    RICH_MESSAGE_RECEIPT: 12,
    RICH_MESSAGE_OTHER: 13
};

/**
 * @export BubbleType
 */
export default BubbleType;
